<template>
  <div class="bg-gray-50 py-6 pb-24 space-y-6" dir="rtl">
    <div class="max-w-2xl mx-auto px-4 space-y-6">
      
      <!-- Date Range -->
      <div class="bg-white rounded-xl p-5 border border-gray-200">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('fromDate') }}</label>
            <date-picker v-model="start_date" />
          </div>
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('toDate') }}</label>
            <date-picker v-model="end_date" />
          </div>
        </div>
      </div>

      <!-- Skeleton -->
      <div v-if="pageLoading" class="pay-report-skeleton-group space-y-3" aria-hidden="true">
        <div
          v-for="n in skeletonCardCount"
          :key="'paid-sk-' + n"
          class="skeleton-block skeleton-paid-card"
        ></div>
      </div>

      <!-- Empty State -->
      <div v-else-if="list.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2V5zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
      </div>

      <!-- Reports List -->
      <div v-else class="space-y-3">
        <div 
          v-for="item in list"
          :key="item.Id"
          class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow"
        >
          <!-- Header -->
          <div class="flex items-center gap-3 mb-4">
            <div class="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="w-full">
              <p class="text-xs text-gray-500 mb-1">شماره سند</p>
              <h3 class="text-sm text-gray-900">{{ item.DocNo }}</h3>
            </div>
          </div>

          <!-- Kardex Cash No -->
          <div class="p-3 bg-gray-50 flex justify-between gap-3  rounded-lg mb-4">
            <p class="text-xs text-gray-600 mb-1">شماره کاردکس</p>
            <p class="text-sm font-bold text-gray-900">{{ item.KardexCashNo }}</p>
          </div>

          <!-- Table -->
          <div class="overflow-hidden rounded-lg border border-gray-200">
            <table class="w-full text-sm">
              <thead class="bg-green-50">
                <tr>
                  <th class="px-3 py-2 text-center text-xs font-bold text-gray-700 border-b border-gray-200">بدهکار</th>
                  <th class="px-3 py-2 text-center text-xs font-bold text-gray-700 border-b border-gray-200">بستانکار</th>
                  <th class="px-3 py-2 text-center text-xs font-bold text-gray-700 border-b border-gray-200">مانده (بد)</th>

                  <th class="px-3 py-2 text-center text-xs font-bold text-gray-700 border-b border-gray-200">مانده (بس)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="px-3 text-center py-2 text-xs  text-red-600 border-b border-gray-100">{{ item.AccBalanceNegetive }}</td>
                  <td class="px-3 text-center py-2 text-xs  text-green-600 border-b border-gray-100">{{ item.AccBalance }}</td>
                  <td class="px-3 text-center py-2 text-xs  text-gray-900 border-b border-gray-100">{{ item.AmountNegetive }}</td>

                  <td class="px-3 text-center py-2 text-xs  text-gray-900 border-b border-gray-100">{{ item.Amount }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'

import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {bus} from '../../main'
import {longClickDirective} from 'vue-long-click'
import Vue from 'vue'
import mapboxgl from "mapbox-gl";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

const longClickInstance = longClickDirective({delay: 500, interval: 5000})
Vue.directive('longclick', longClickInstance)
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
import moment from 'moment-jalaali'
import { skeletonSilentRequest } from '../../utils/skeletonPages'

export default {
  props: [
    'passing_data'
  ],

  data() {
    return {
      first_load:true,
      list: [],
      pageLoading: true,
      skeletonCardCount: 4,
      start_date: "",
      end_date: "",
    }
  },
  components: {
    InfiniteLoading,
    Treeselect,
    datePicker: VuePersianDatetimePicker,

  },
  watch: {
    "start_date": function () {
      this.list = []
      this.pageLoading = true
      this.get_data(1);

    },
    "end_date": function () {
      this.list = []
      this.pageLoading = true

      this.get_data(1);

    },
  },
  mounted() {
    this.start_date = moment().utc().format('jYYYY/jMM/jDD');
    this.end_date = moment().utc().format('jYYYY/jMM/jDD');
    this.list = []
    const self = this
    setTimeout(function (){
      self.first_load = false
      self.get_data(1);
    },300)

  },

  methods: {
    get_data(page) {
      console.log("this.first_load",this.first_load,page)
      if(this.first_load){
        return false
      }
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        PageNo: page,
        txtCode: "",
        isOld: 0,
        fdate: this.start_date,
        sdate: this.end_date,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetPersonAccounts', send_data, skeletonSilentRequest)
        .then(response => {
          if (response.data.items.length > 0) {
            self.list.push(...response.data.items)

            self.get_data(page + 1)
          }

        }).catch(e => {
        this.errors.push(e)
      }).finally(() => {
        if (page === 1) {
          self.pageLoading = false
        }
      })
    },

  }
}
</script>
<style>
.table-border{
  border-collapse: collapse;

}
.table-border td{
  border:1px solid grey;
  padding: 2px;
}

.pay-report-skeleton-group {
  position: relative;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.pay-report-skeleton-group::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 45%,
    rgba(255, 255, 255, 0.65) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: pay-report-skeleton-shimmer 1.4s ease-in-out infinite;
}

.pay-report-skeleton-group .skeleton-block {
  background-color: #e5e7eb;
}

.skeleton-paid-card {
  min-height: 12rem;
  border-radius: 0.75rem;
}

@keyframes pay-report-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
